<template>
  <!-- <div class="scroll-wrapper"> -->
  <full-page ref="fullpage" class="fullpage_wrapper" :options="pageOption" id="fullpage">
    <div class="section section01">
      <div class='logo'>
        <img :src="require('../assets/Logo.svg')" alt="">
      </div>
      <div class='full'>
        <div class="arrow-wrapper more" @click="$refs.fullpage.api.moveSectionDown()">
          <div class="arrow"></div>
        </div>
      </div>
    </div>
    <div class="section section02">
      <div class="section-cell">
        <div class="container">
          <div class="text-wrapper">
            <div class="text">나는
              <input v-model='date' maxlength=2 :style='{width:dateLength}' name="" id="" class='date'>일에</div>
            <div class="text">
              <input v-model='salary' @input="salaryFormat" @keyup="calcSalary" :style='{width:salaryLength}' name="" id="" class='number'>원 받는다.</div>
          </div>
          <div class="location_wrap">
            <span>당신의 샐러리 랭킹을 알아보세요!</span>
            <img v-show="rank" :src="require('../assets/location.svg')" alt="" class="location_icon" :style="{left: rank + '%'}">
          </div>
          <el-progress :text-inside="true" :stroke-width="3" :percentage="rank" color="#2EF388" />
          <div class="percent_wrap">
            <span v-show="rank" :style="{left: rank + '%'}">{{rank}} %</span>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class='full' v-show="showResult">
          <div class="arrow-wrapper" @click="$refs.fullpage.api.moveSectionDown()">
            <div class="arrow"></div>
          </div>
        </div>
      </transition>
    </div>
    <div class="section section03">
      <div class="section-cell">
        <div class="container">
          <div class="text-wrapper">
            <div class="text">오늘 출근해서</div>
            <div class="text">
              <CountUp class="number" :startVal="0" :endVal="todayGaze" :decimals="countOption.decimals" :duration="countOption.duration" :options="countOption.options" />원 벌었다.</div>
            <el-carousel height="80px" class="unit_carousel" :interval="2000">
              <el-carousel-item>
                {{chicken}} 치킨
              </el-carousel-item>
              <el-carousel-item>
                {{coffee}} 커피
              </el-carousel-item>
              <el-carousel-item>
                {{macbook}} 맥북
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="location_wrap">
            <span>일급 게이지가 차고있어요! 힘내세요 :)</span>
            <img v-show="todayPercent" :src="require('../assets/location2.svg')" alt="" class="location_icon" :style="{left: todayPercent + '%'}">
          </div>
          <el-progress :text-inside="true" :stroke-width="3" :percentage="todayPercent" color="#2EF388" />
          <div class="percent_wrap">
            <span :style="{left: todayPercent + '%'}">{{todayPercent}} %</span>
          </div>
        </div>
        <div class='full'>
          <div class="arrow-wrapper" @click="$refs.fullpage.api.moveSectionDown()">
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section04">
      <div class="section-cell">
        <div class="container">
          <div class="text-wrapper">
            <div class="text">지금 사표 내면</div>
            <div class="text">
              <CountUp class="number" :startVal="0" :endVal="monthGaze" :decimals="countOption.decimals" :duration="countOption.duration" :options="countOption.options" />원 받는다.</div>
          </div>
          <div class="location_wrap">
            <span>월급 게이지가 차고있어요! 화이팅 :)</span>
            <img v-show="monthPercent" :src="require('../assets/location3.svg')" alt="" class="location_icon" :style="{left: monthPercent + '%'}">
          </div>
          <el-progress :text-inside="true" :stroke-width="3" :percentage="monthPercent" color="#F50805" />
          <div class="percent_wrap">
            <span :style="{left: monthPercent + '%'}">{{monthPercent}} %</span>
          </div>
        </div>
        <div class='full'>
          <div class="arrow-wrapper">
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
  </full-page>
  <!-- </div> -->
</template>

<script>
  import axios from '@/customAxios.js';
  import _ from 'underscore';
  import CountUp from 'vue-countup-v2';
  export default {
    data() {
      return {
        date: 1,
        salary: 0,
        page: 0,
        todayGaze: 0,
        monthGaze: 0,
        showResult: false,
        pageOption: {},
        todayPercent: 0,
        monthPercent: 0,
        rankSalary: 0,
        countOption: {
          decimals: 0,
          duration: 2.5,
          options: {
            useEasing: true,
            useGrouping: true,
            separator: ',',
            decimal: '.'
          },
        },
        rank: 0
      }
    },
    computed: {
      dateLength() {
        return this.date.length ? ((this.date.length) * 30) + 'px' : '20px'
      },
      salaryLength() {
        return this.salary.length ? ((this.salary.length) * 55) + 'px' : '40px'
      },
      chicken(){
        return parseFloat((this.todayGaze / 20000))
      },
      coffee(){
        return parseFloat((this.todayGaze / 5000))
      },
      macbook(){
        return parseFloat((this.todayGaze / 2500000))
      }
    },
    methods: {
      salaryFormat(){
        if (this.salary) this.salary = parseInt(this.salary.replace(/,/g, '')).toLocaleString();
      },
      calcSalary(){
        let month1 = [31 , 22]; 
        let month2 = [31 , 22];
        let month3 = [31 , 22]; 
        let month4 = [31 , 22]; 
        let month5 = [31 , 22];
        let month6 = [31 , 22];
        let month7 = [31 , 22]; 
        let month8 = [31 , 22];
        let month9 = [30 , 17]; 
        let month10 = [31 , 22]; 
        let month11 = [30 , 22];
        let month12 = [31 , 20];

        let month2018 = [month1 , month2 , month3 , month4, month5, month6, month7, month8, month9, month10, month11, month12]; 

        let payday = parseInt(this.date); // 월급날 
        let pay = parseInt(this.salary.replace(/,/g, ''));  //월급

        let startTime = 9;  // 근무 시작시간
        let workTime = 9;   //근무 시간 

        //시연할떄 필요할 거 같아서 

        let adminDate = 25; // 날짜 지정
        let adminHours = 0;    // 시간 지정  

        if(payday>31 || payday<0 ){
            console.log("다시 입력");
        }

        else{

            var dt = new Date();

            if(adminDate!==0 ){
                dt.setDate(adminDate);        
            }
            if(adminHours!==0){
                dt.setHours(adminHours);
            }

            let date = dt.getDate();
            let nowMonth = dt.getMonth()+1;
            let month = month2018[nowMonth]; 


            var preMonth = new Date();
            preMonth.setDate(payday);
            preMonth.setMonth(dt.getMonth()-1);

            // // test
            // dt.setHours(10);
            // dt.setDate(2);

            let monthCount =0;
            var test =preMonth;

            // for(var i=0; i<31; i++){
            //     test.setDate(test.getDate()+1)

            //     if(test.getDay()!==6 && test.getDay()!==0){
            //         monthCount++;
            //     }
              
            // }

            monthCount=30;

            console.log(monthCount);

            var preMonth = new Date();
            preMonth.setDate(payday);
            preMonth.setMonth(dt.getMonth()-1);
            var test =preMonth;
            let workCount = 0;



            let second = ((((pay/30)/24)/60)/60)*dt.getSeconds()-(((pay/30)/60)/60);
            let minute = (((pay/30)/24)/60)*dt.getMinutes()-((pay/30)/60);

            let monthGaze=0;



            if(payday>dt.getDate()){
                
                while(true){
                    test.setDate(test.getDate()+1)

                    // if(test.getDay()!==6 && test.getDay()!==0){
                    //     workCount++;
                    // }

                    workCount++;

                    if(test.getDate()===dt.getDate() && test.getMonth()===dt.getMonth()){
                        break;
                    }
                }

                monthGaze = (pay/monthCount)*workCount +minute+second;
            }

            else if(payday===dt.getDate()){
                monthGaze = pay +minute+second;
            }

            else{

                var test = new Date(); 
                test.setDate(payday);

                // console.log(payday + " " + test.getDate());
                
                for(var i=payday; i<dt.getDate(); i++){
                    test.setDate(test.getDate()+1)   

                    // if(test.getDay()!==6 && test.getDay()!==0){
                    //     workCount++;
                    // }

                    workCount++;
                    
                }

                monthGaze = (pay/monthCount)*workCount +minute+second;

            }

            console.log(dt);
            console.log(workCount);



            let todayGaze = 0;

            // if(dt.getDay()!==6 && dt.getDay()!==0){      // 오늘이 평일이라면 지금까지 번 돈이 todayGaze랑 같이 올라가도록 하루치를 뺴고 todayGaze 플러스 

                if(startTime<dt.getHours() && dt.getHours()<(startTime+workTime)){   //지금 시간이 오전 9 to 6 사이일떄
                    todayGaze = ((pay/month[1])/9)*(dt.getHours()-9)+minute+second;    
                }
            
                else if((startTime+workTime)<=dt.getHours() && dt.getHours()<24){      // 6시 부터 12시까지
                    todayGaze=pay/month[1];
                }

                monthGaze = monthGaze-(pay/month[1])+todayGaze;
            // }

            if(monthGaze>pay){
                monthGaze=pay;
            }

            console.log(todayGaze, monthGaze, second);

              
          this.fetchGaze(todayGaze, monthGaze);
        }
      },
      fetchGaze(t, m) {
        this.todayGaze = Math.floor(Math.round(t)/10) * 10;
        this.monthGaze = Math.floor(Math.round(m)/10) * 10;
        let tp = (this.todayGaze / (parseInt(this.salary.replace(/,/g, '')) / 22)) * 100;
        let mp = (this.monthGaze / parseInt(this.salary.replace(/,/g, ''))) * 100;
        
        this.todayPercent = parseFloat(tp.toFixed(2));
        this.monthPercent = parseFloat(mp.toFixed(2));

        this.resultToggle();
      },
      resultToggle: _.debounce(function(e) {
        this.insertRank();
        this.showResult = !this.showResult;

        let salaryCheck = this.salary == 0 || this.salary == "";

        if (!salaryCheck) {
          fullpage_api.setAllowScrolling(true);
        } else {
          fullpage_api.setAllowScrolling(false);
        }
      }, 500),
      getTotalRank(){
        this.axios.get('/list').then(res => {
          console.log(res.data)
        }, err => {
          console.log(err);
        });
      },
      insertRank(){
        let salary = parseInt(this.salary.replace(/,/g, ''));
        this.axios.post(`/insert/${salary}`).then(res => {
          this.rank = parseFloat((100 - (res.data * 100)).toFixed(2));
        }, err => {
          console.log(err);
        })
      },
      handleScroll(){
        let sect = fullpage_api.getActiveSection().index;
        let salaryCheck = this.salary == 0 || this.salary == "";

        if (salaryCheck) {
          fullpage_api.setAllowScrolling(false);
        }
      },
      increaseTodayGaze: function(){
        const self = this;
        this.todayGaze = setInterval(() => {
            let inc = self.monthGaze / 30 / 9 / 60 / 60;
            let changes = (self.todayGaze += inc);
            self.todayGaze = changes;
        }, 1000);
      }
    },
    created(){
      this.increaseTodayGaze();
      window.addEventListener('wheel', this.handleScroll);
    },
    destroyed(){
      window.removeEventListener('wheel', this.handleScroll);
    },
    mounted(){
      // fullpage_api.setAllowScrolling(false);
    },
    watch: {
      salary(nv){
        if (nv == "NaN") this.salary = 0;
      },
      todayPercent(nv){
        this.todayPercent = nv;
      },  
      monthPercent(nv){
        this.monthPercent = nv;
      }
    },
    components: {
      CountUp
    }
  }
</script>

<style lang="scss">
@import '@/style/common.scss';

  .logo {
    max-width: 400px;
    width: 100%;
    margin: 0 auto;
  }

  .fp-tableCell {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-flow: column wrap; 
  }
  .scroll-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .fullpage_wrapper .section {
    display: table;
    width: 100vw;
    height: 100vh;
    position: relative;
  }

  .scroll-content .section .section-cell {
    display: table-cell;
    width: 100vw;
    height: 100vh;
    vertical-align: middle;
  }

  .text-wrapper {
    display: inline-block;
  }

  .text {
    text-align: left;
    font-size: 50px;
    font-weight: 300;
    color: #9b9b9b;
  }

  input.date {
    min-width: 40px;
    font-size: 50px;
    font-weight: 100;
    text-align: center;
    color: #4a4a4a;
    border: 0;
    border-bottom: 2px solid #4a4a4a;
    outline: none;
  }

  input.number {
    min-width: 60px;
    font-size: 100px;
    font-weight: 100;
    text-align: left;
    color: #4a4a4a;
    border: 0;
    border-bottom: 2px solid #4a4a4a;
    outline: none;
  }

  a.number {
    font-size: 100px;
    font-weight: 100;
    text-align: left;
    color: #4a4a4a;
  }

  span.number {
    margin-right: 10px;
    font-weight: 100;
    font-size: 100px;
    color: #4a4a4a;
  }

  .fullpage_wrapper .full {
    position: absolute;
    left: 0;
    bottom: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }

  .arrow {
    width: 20px;
    height: 20px;
    border-bottom: 2px solid #d8d8d8;
    border-left: 2px solid #d8d8d8;
    transform: rotateZ(-45deg);
    display: inline-block;
    text-align: center;
    position: relative;
  }

  .arrow-wrapper {
    display: inline-block;
  }

  .arrow-wrapper.more::before {
    display: block;
    content: 'Show More';
    color: #d8d8d8;
    bottom: 20px;
  }

  .section01, .section02, .section03, .section04 {
    .fp-tableCell {
      align-items: stretch;
    }

    .container {
      text-align: center;
    }
  }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

  .el-progress {
    margin-top: 5px;
    width: 100%;
  }

  .section03 {
    .el-progress {
      .el-progress-bar__inner {
        background: linear-gradient(to right, #7CFE79, #2DF388) !important;
      }
    }

    .container {
      align-items: stretch !important;
    }

    .text {
      text-align: center;
    }
  }

  .section02 {
    .el-progress-bar__inner {
      background: linear-gradient(to right, #FE8B5D, #F50201) !important;
    }
  }
  
  
  .section04 {
    .el-progress {
      .el-progress-bar__inner {
        background: linear-gradient(to right, #A6D1F7, #0020FE) !important;
      }
    }
    .container {
      align-items: stretch !important;
    }

    .text {
      text-align: center;
    }
  }

  .section03 .container,
  .section04 .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column wrap;
  }

  .location_wrap {
    margin-top: 100px;
    text-align: left;
    position: relative;
    width: 100%;

    span {
      position: absolute;
      top: -60px;
      margin-left: 0px;
      font-size: 16px;
      font-weight: 200;
      color: #acacac;
    }

    img {
      position: absolute;
      top: -25px;
      margin-left: 0px;
    }
    

    &::after {
      position: absolute;
    }
  }

  .percent_wrap {
    width: 100%;
    position: relative;
    text-align: left;

    span {
      position: absolute;
      bottom: -25px;
    }
  }

  .section02 .percent_wrap span {
    color: #f50503;
  }

  .section04 .percent_wrap span {
    color: #7f8ff7;
  }
  .section03 .percent_wrap span {
    color: #30f387;
  }

  .unit_carousel {
    width: 100%;
  }

  .el-carousel__item {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: 300;
    color: #9b9b9b;
  }

  @media screen and (max-width: 767px) {
    .section02 {
      display: block;
      width: 100%;

      input.number {
        font-size: 65px;
        width: 100% !important;
        margin: 8px 0;
      }

      input.date {
        font-size: 35px;
      }
    }

    span.number {
      font-size: 65px;
    }

    .text {
      font-size: 30px;
    }

    .el-carousel__item {
      font-size: 25px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Main.vue